import PropTypes from 'prop-types';
import React, { useLayoutEffect, useState } from 'react';
import { Tooltip } from 'reactstrap';
import { kebabCase } from 'lodash';
const ConformanceTooltip = ({
  errorText: _errorText = null,
  placement: _placement = 'bottom',
  target: _target = null
}) => {
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const [targetReady, setTargetReady] = useState(false);
  useLayoutEffect(() => {
    setTooltipIsOpen(false);
    if (!_target) {
      setTargetReady(false);
      return undefined;
    }
    setTargetReady(!!document.getElementById(_target));
    return undefined;
  }, [_target]);
  if (!_errorText || !_errorText.length || !_target || !targetReady) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Tooltip, {
    trigger: "hover",
    placement: _placement,
    isOpen: tooltipIsOpen,
    "data-testid": `t-ct-${kebabCase(_errorText)}`,
    target: _target,
    toggle: () => {
      setTooltipIsOpen(prev => {
        if (prev) {
          return false;
        }
        return !!document.getElementById(_target);
      });
    },
    autohide: false
  }, _errorText);
};
ConformanceTooltip.propTypes = {
  errorText: PropTypes.string,
  target: PropTypes.string,
  placement: PropTypes.string
};
export default ConformanceTooltip;